import { renderActions } from "./renderUtils";

export const getColumns = (handleShowInfo) => [
  {
    field: "id",
    headerName: "ID",
    width: 60,
  },
  // {
  //   field: "transactionUuid",
  //   headerName: "UUID",
  //   width: 300,
  // },
  {
    field: "firstName",
    headerName: "First Name",
    width: 170,
  },
  {
    field: "lastName",
    headerName: "Last Name",
    width: 170,
  },
  {
    field: "transactionStatus",
    headerName: "Status",
    width: 280,
  },
  {
    field: "travelerId",
    headerName: "Traveler ID",
    width: 100,
  },
  {
    field: "travelId",
    headerName: "Travel ID",
    width: 100,
  },
  {
    field: "personDecision",
    headerName: "Person Decision",
    width: 200,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    renderCell: (params) => renderActions(params, handleShowInfo),
    sortable: false,
    filterable: false,
  },
];

export default getColumns;
